import { useEffect, useState } from 'react'

export default function useFilePreview(file: any) {
  try {
    const [imgSrc, setImgSrc] = useState<any>({
      file: null,
      error: null,
    })

    useEffect(() => {
      if (typeof file == 'string') {
        setImgSrc({ file: file, error: null })
      } else if (file && file?.[0]) {
        if (
          file?.[0]?.type === 'image/jpg' ||
          file?.[0]?.type === 'image/svg' ||
          file?.[0]?.type === 'image/jpeg' ||
          file?.[0]?.type === 'image/png' ||
          file?.[0]?.type === 'image/gif'
        ) {
          const newUrl: any = URL.createObjectURL(file[0])
          if (newUrl !== imgSrc)
            setImgSrc({ ...imgSrc, file: newUrl, error: null })
        } else {
          setImgSrc({
            ...imgSrc,
            file: null,
            error:
              'Invalid file format. Please upload an image file (svg,jpg, jpeg, png, gif).',
          })
        }
      } else if (file === null || file === undefined) {
        setImgSrc({
          file: null,
          error: null,
        })
      }
      // else {
      //   setImgSrc({ ...imgSrc, file: null, error: 'No file uploaded.' })
      // }
    }, [file])

    return [imgSrc, setImgSrc]
  } catch (err) {
    console.error(err) // Log the error for debugging
    return [{ file: null, error: 'An error occurred.' }] // Return a generic error message
  }
}
